/* Onda Br Marketing — interactions. No dependencies. */
(function () {
  var doc = document.documentElement, body = document.body;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  requestAnimationFrame(function () { body.classList.add('is-loaded'); });
  setTimeout(function () { body.classList.add('is-loaded'); }, 400);

  var dl = window.dataLayer = window.dataLayer || [];
  var lang = doc.getAttribute('lang') || 'en';

  // cookie consent (Consent Mode v2 defaults are set in <head>)
  var banner = document.getElementById('ob-consent');
  var stored = null;
  try { stored = localStorage.getItem('ob_consent'); } catch (e) {}
  if (banner && !stored) banner.hidden = false;
  document.querySelectorAll('[data-consent]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.getAttribute('data-consent');
      try { localStorage.setItem('ob_consent', v); } catch (e) {}
      if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', { ad_storage: v, ad_user_data: v, ad_personalization: v, analytics_storage: v });
      }
      dl.push({ event: 'ob_consent', consent_choice: v });
      banner.hidden = true;
    });
  });

  // signals for GTM (GTM decides what to send to GA4)
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-cta]');
    if (cta) dl.push({ event: 'ob_cta', cta_location: cta.getAttribute('data-cta'), cta_text: (cta.textContent || '').trim().slice(0, 60), cta_url: cta.getAttribute('href') || '' });
    var work = e.target.closest('.work-link, .work-card a.cover');
    if (work) {
      var card = work.closest('.work-card'), h = card && card.querySelector('h3');
      dl.push({ event: 'ob_portfolio', project_name: h ? h.textContent.trim() : '', project_url: work.getAttribute('href') || '' });
    }
    var lb = e.target.closest('.lang-switch button');
    if (lb) dl.push({ event: 'ob_lang', lang_from: lang, lang_to: lb.value });
  }, true);

  // home work reel: one site at a time, story-style progress bars
  document.querySelectorAll('[data-reel]').forEach(function (reel) {
    var slides = reel.querySelectorAll('[data-slide]'), dots = reel.querySelectorAll('.reel-dot'), cur = 0;
    if (!slides.length) return;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
      dots.forEach(function (d, k) {
        d.classList.remove('is-active'); d.classList.toggle('is-done', k < cur);
        if (k === cur) { void d.offsetWidth; d.classList.add('is-active'); }
      });
    }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k); });
      d.querySelector('.reel-bar i').addEventListener('animationend', function () { if (k === cur) go(cur + 1); });
    });
    if (reduce) { reel.classList.add('is-paused'); }
    reel.addEventListener('pointerenter', function () { reel.classList.add('is-paused'); });
    reel.addEventListener('pointerleave', function () { if (!reduce) reel.classList.remove('is-paused'); });
  });

  // contact form: the only conversion
  var form = document.getElementById('ob-contact-form');
  if (form) {
    var started = Date.now();
    var ok = form.querySelector('[data-ob-success]');
    if (ok) {
      // fire once per real submission (not on refresh)
      var pending = null;
      try { pending = JSON.parse(sessionStorage.getItem('ob_lead_pending') || 'null'); sessionStorage.removeItem('ob_lead_pending'); } catch (e) {}
      if (pending) dl.push({ event: 'ob_lead', form_name: 'contact', service_interest: pending.service, budget_range: pending.budget, form_lang: lang });
    } else {
      var firstTouch = false;
      form.addEventListener('focusin', function () {
        if (!firstTouch) { firstTouch = true; dl.push({ event: 'ob_form_start', form_name: 'contact' }); }
      });
      form.addEventListener('submit', function (e) {
        var hp = form.querySelector('#ob-hp');
        var tooFast = Date.now() - started < 3000;
        if ((hp && hp.value) || tooFast) { e.preventDefault(); return; }
        var bad = false;
        form.querySelectorAll('[required]').forEach(function (f) {
          var empty = !f.value.trim(), invalid = f.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.value);
          f.setAttribute('aria-invalid', (empty || invalid) ? 'true' : 'false');
          if (empty || invalid) bad = true;
        });
        if (bad) { e.preventDefault(); var first = form.querySelector('[aria-invalid="true"]'); if (first) first.focus(); return; }
        var t = form.querySelector('[data-ob-started]'); if (t) t.value = String(Math.round((Date.now() - started) / 1000)) + 's';
        try { sessionStorage.setItem('ob_lead_pending', JSON.stringify({ service: (form.querySelector('[data-ob-service]') || {}).value || '', budget: (form.querySelector('[data-ob-budget]') || {}).value || '' })); } catch (err) {}
        var btn = form.querySelector('button[type="submit"]'); if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-sending') + '…'; }
      });
    }
  }

  // fit: shrink giant headings only when a word is wider than its box (long ES/PT words)
  function fit(el) {
    el.style.fontSize = '';
    el.classList.add('fit-measure');
    var fs = parseFloat(getComputedStyle(el).fontSize), guard = 0;
    while (el.scrollWidth > el.clientWidth + 2 && guard++ < 40) { fs *= .95; el.style.fontSize = fs + 'px'; }
    el.classList.remove('fit-measure');
  }
  var fits = document.querySelectorAll('.hero h1, .contact h2, .work-hero h1, .section-head h2, .culture-teaser h2');
  function fitAll() { fits.forEach(fit); }
  fitAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fitAll, 150); });

  // header: glass on scroll, hide on scroll down
  var header = document.querySelector('.site-header'), lastY = 0;
  function onScroll() {
    var y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 30);
    header.classList.toggle('is-hidden', y > 400 && y > lastY && !body.classList.contains('nav-open'));
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // mobile nav
  var toggle = document.querySelector('.menu-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = body.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open);
    });
    document.querySelectorAll('.main-nav a').forEach(function (a) {
      a.addEventListener('click', function () { body.classList.remove('nav-open'); toggle.setAttribute('aria-expanded', false); });
    });
  }

  // scroll reveal
  var targets = document.querySelectorAll('[data-reveal], .step');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: .12 });
    targets.forEach(function (t) { io.observe(t); });
  } else {
    targets.forEach(function (t) { t.classList.add('is-in'); });
  }

  if (reduce || !fine) return;

  // cursor glow
  var glow = document.querySelector('.cursor-glow');
  var gx = 0, gy = 0, tx = 0, ty = 0;
  window.addEventListener('pointermove', function (e) {
    tx = e.clientX; ty = e.clientY; body.classList.add('has-pointer');
  }, { passive: true });
  (function loop() {
    gx += (tx - gx) * .12; gy += (ty - gy) * .12;
    if (glow) glow.style.transform = 'translate3d(' + gx + 'px,' + gy + 'px,0)';
    requestAnimationFrame(loop);
  })();

  // magnetic buttons
  document.querySelectorAll('.btn').forEach(function (b) {
    b.addEventListener('pointermove', function (e) {
      var r = b.getBoundingClientRect();
      b.style.setProperty('--bx', ((e.clientX - r.left - r.width / 2) * .25) + 'px');
      b.style.setProperty('--by', ((e.clientY - r.top - r.height / 2) * .35) + 'px');
    });
    b.addEventListener('pointerleave', function () {
      b.style.setProperty('--bx', '0px'); b.style.setProperty('--by', '0px');
    });
  });

  // 3D tilt on work cards
  document.querySelectorAll('.work-card').forEach(function (c) {
    c.addEventListener('pointermove', function (e) {
      var r = c.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      c.style.transform = 'perspective(1200px) rotateY(' + (x * 4) + 'deg) rotateX(' + (-y * 4) + 'deg)';
    });
    c.addEventListener('pointerleave', function () { c.style.transform = ''; });
  });
})();
